class BfvFavoritenDisplay {
  constructor(options = {}) {
    this.$root = options.element;
    this.$favoriteEntries = this.$root.querySelectorAll('.js-slide-entry');
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.$favoriteEntries.forEach(($favorite) => {
      $favorite.addEventListener('click', () => {
        document.location.href = $favorite.dataset.clickUrl;
      });
    });
  }
}

export default BfvFavoritenDisplay;



// WEBPACK FOOTER //
// ./src/javascript/main/BfvFavoritenDisplay/index.js